import { render, staticRenderFns } from "./VueHazardmapSheltersComponent.vue?vue&type=template&id=60fd5739&lang=pug&"
import script from "./VueHazardmapSheltersComponent.vue?vue&type=script&lang=js&"
export * from "./VueHazardmapSheltersComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/k-aso/works/city.yokote.lg.jp/yokote-hazard.com/city.yokote.lg.jp_yokote-hazard.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60fd5739')) {
      api.createRecord('60fd5739', component.options)
    } else {
      api.reload('60fd5739', component.options)
    }
    module.hot.accept("./VueHazardmapSheltersComponent.vue?vue&type=template&id=60fd5739&lang=pug&", function () {
      api.rerender('60fd5739', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/VueHazardmapSheltersComponent.vue"
export default component.exports